import Marquee from "react-fast-marquee";

export const EditorialMarquee = ({ words }) => {
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-[#172033] bg-[#172033] py-10 md:py-14 overflow-hidden"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-display italic text-[#D9B87A] text-4xl md:text-7xl px-8 md:px-14">
              {w}
            </span>
            <span className="font-serif-display text-[#B0863A] text-4xl md:text-7xl">·</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
